import { render, staticRenderFns } from "./CardDashBoard.vue?vue&type=template&id=02050fa8&"
import script from "./CardDashBoard.vue?vue&type=script&lang=js&"
export * from "./CardDashBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports